export default __webpack_public_path__ + "static/media/dYdX.a4830b98.svg";